import { useState } from "react";
import { supabase } from "@/lib/supabase";
import { useNavigate } from "react-router-dom";

export default function ForgotPasswordPage() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    setMsg(null);
    setLoading(true);

    try {
      // Supabase email linkine tıklayınca nereye dönsün?
      // Bu sayfa, şifreyi gerçekten değiştireceğimiz sayfa olacak (bir sonraki adımda ekleyeceğiz).
      const redirectTo = `${window.location.origin}/sifre-sifirla`;

      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo,
      });

      if (error) {
        setErr(error.message);
      } else {
        setMsg(
          "Şifre sıfırlama linki e-postanıza gönderildi. Gelen kutusu / spam kontrol edin.",
        );
      }
    } catch (e: any) {
      setErr(e?.message || "Bir hata oluştu.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-black/30 p-6 backdrop-blur">
        <h1 className="text-2xl font-semibold mb-2">Şifremi Unuttum</h1>
        <p className="text-sm text-white/70 mb-6">
          E-posta adresinizi yazın, şifre sıfırlama linki gönderelim.
        </p>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="text-sm text-white/80">E-posta</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full rounded-xl bg-white/10 border border-white/10 px-3 py-2 outline-none"
              placeholder="ornek@mail.com"
              required
            />
          </div>

          {err && (
            <div className="rounded-xl border border-red-500/30 bg-red-500/10 p-3 text-sm text-red-200">
              {err}
            </div>
          )}

          {msg && (
            <div className="rounded-xl border border-emerald-500/30 bg-emerald-500/10 p-3 text-sm text-emerald-200">
              {msg}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-xl bg-rose-600 hover:bg-rose-700 disabled:opacity-60 px-4 py-2 font-medium"
          >
            {loading ? "Gönderiliyor..." : "Şifre Sıfırlama Linki Gönder"}
          </button>

          <button
            type="button"
            onClick={() => navigate("/giris")}
            className="w-full rounded-xl border border-white/15 hover:bg-white/5 px-4 py-2 font-medium"
          >
            Giriş sayfasına dön
          </button>
        </form>
      </div>
    </div>
  );
}
